import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link as ScrollLink, Element } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  return (
    <div
      style={{
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      {/* Bandeau en haut */}
      <div style={headerStyle}>
        <span style={logoStyle} onClick={() => navigate("/")} role="button">
          Dansy
        </span>
        <h1 style={titleStyle}>Accueil</h1>
      </div>

      {/* Styles globaux pour le carrousel (keyframes) */}
      <style>
        {`
            @keyframes scrollTestimonials {
              0% {
                  transform: translateX(0%);
              }
              100% {
                  transform: translateX(-100%);
              }
            }
        `}
      </style>

      {/* Hero Section */}
      <section style={heroSectionStyle}>
        <div style={heroContentStyle}>
          <h1 data-aos="fade-down" style={heroTitleStyle}>
            Bienvenue sur{" "}
            <span style={{ color: "#ff477e", fontFamily: "'Shirkhand', cursive" }}>
              Dansy
            </span>
          </h1>

          <p data-aos="fade-up" style={heroSubtitleStyle}>
            La plateforme idéale pour créer et gérer des chorégraphies collaboratives.
          </p>

          <button
            onClick={() => navigate("/sessions")}
            style={heroButtonStyle}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Commencer
          </button>

          <ScrollLink
            to="features"
            smooth={true}
            duration={800}
            style={heroScrollLinkStyle}
          >
            Voir les fonctionnalités ↓
          </ScrollLink>
        </div>
      </section>

      {/* Features Section */}
      <Element name="features">
        <section style={featuresSectionStyle}>
          <h2 style={featuresTitleStyle} data-aos="fade-up">
            Pourquoi choisir{" "}
            <span style={{ color: "#ff477e", fontFamily: "'Shirkhand', cursive" }}>
              Dansy
            </span>
          </h2>
          <div style={featuresGridStyle}>
            <div data-aos="zoom-in" style={featureCardStyle}>
              <h3 style={featureTitleStyle2}>Collaboratif</h3>
              <p style={featureTextStyle}>
                Invitez vos danseurs et travaillez ensemble pour créer des mouvements synchronisés.
              </p>
            </div>
            <div data-aos="zoom-in" data-aos-delay="200" style={featureCardStyle}>
              <h3 style={featureTitleStyle2}>Intuitif</h3>
              <p style={featureTextStyle}>
                Une interface claire et intuitive pour organiser vos sessions sans effort.
              </p>
            </div>
            <div data-aos="zoom-in" data-aos-delay="400" style={featureCardStyle}>
              <h3 style={featureTitleStyle2}>Performant</h3>
              <p style={featureTextStyle}>
                Gérez des chorégraphies complexes grâce à nos outils puissants et réactifs.
              </p>
            </div>
          </div>
        </section>
      </Element>

      {/* Testimonials Section */}
      <section style={testimonialsSectionStyle}>
        <h2 style={testimonialsTitleStyle} data-aos="fade-up">
          Ce que nos utilisateurs disent de nous
        </h2>
        <div style={testimonialsContainerStyle}>
          {/* Le "cylindre" de cartes qui défile */}
          <div style={testimonialsSliderStyle}>
            {testimonials.map((t, index) => (
              <div
                key={index}
                style={testimonialCardStyle}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <p style={testimonialTextStyle}>{t.text}</p>
                <div style={testimonialStarsStyle}>★★★★★</div>
                <p style={testimonialAuthorStyle}>{t.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer style={footerStyle}>
        <p style={{ marginBottom: "10px" }}>
          © {new Date().getFullYear()} Dansy. Tous droits réservés.
        </p>
        <p>
          <a href="/terms" style={footerLinkStyle}>
            Mentions légales
          </a>
          {" | "}
          <a href="/privacy" style={footerLinkStyle}>
            Politique de confidentialité
          </a>
        </p>
      </footer>
    </div>
  );
}

/*--------------------------------
  Données
---------------------------------*/

/* Longue liste de témoignages pour que ça défile bien */
const testimonials = [
  { text: "Dansy a transformé notre façon de travailler !", author: "– Sarah L." },
  { text: "Une interface fluide et très pratique.", author: "– Tom M." },
  { text: "Je recommande à 100% !", author: "– Clara R." },
  {
    text: "Grâce à Dansy, nos chorégraphies sont plus organisées et plus performantes !",
    author: "– Nina D.",
  },
  {
    text: "Les fonctionnalités d'édition de positions sont top !",
    author: "– Marc P.",
  },
  {
    text: "On peut facilement ajouter de nouveaux danseurs, c’est génial.",
    author: "– Inès V.",
  },
  {
    text: "Simple et puissant, tout ce dont on a besoin !",
    author: "– Lucas G.",
  },
  {
    text: "Le mode trajectoire est tellement pratique pour la mise en scène.",
    author: "– Zoé M.",
  },
];

/*--------------------------------
  STYLES
---------------------------------*/

/* Bandeau (Header) */
const headerStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg, #fff0f3, #ffd6dd)",
  color: "#000",
  padding: "15px",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  height: "30px",
  zIndex: 100,
};

const logoStyle = {
  position: "absolute",
  left: "20px",
  fontSize: "1.7rem",
  fontFamily: "'Shirkhand', cursive",
  color: "#ff477e",
  fontWeight: "bold",
  cursor: "pointer",
};

const titleStyle = {
  fontSize: "1.5rem",
  fontWeight: 700,
};

/* 1) Hero Section */
const heroSectionStyle = {
  position: "relative",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  background: "linear-gradient(135deg, #fff0f3, #ffd6dd)",
  color: "#333",
  textAlign: "center",
  overflow: "hidden",
  padding: "60px 20px", // Ajouté pour plus d'espace
  paddingTop: "80px", // Pour compenser le header fixe
};

const heroContentStyle = {
  textAlign: "center",
  maxWidth: "700px",
};

const heroTitleStyle = {
  fontSize: "4.5rem",
  marginBottom: "1.2rem",
  fontWeight: 700,
};

const heroSubtitleStyle = {
  fontSize: "1.8rem",
  marginBottom: "2.5rem",
  lineHeight: 1.4,
};

const heroButtonStyle = {
  padding: "15px 35px",
  fontSize: "1.2rem",
  backgroundColor: "#ff477e",
  color: "#fff",
  border: "none",
  borderRadius: "50px",
  cursor: "pointer",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  transition: "transform 0.8s ease",
};

const heroScrollLinkStyle = {
  display: "inline-block",
  padding: "15px 35px",
  marginTop: "50px",
  color: "#ff477e",
  fontSize: "1.2rem",
  textDecoration: "none",
  cursor: "pointer",
  fontWeight: 500,
};

/* 2) Features */
const featuresSectionStyle = {
  padding: "80px 20px",
  backgroundColor: "#fff",
  textAlign: "center",
};

const featuresTitleStyle = {
  fontSize: "2.7rem",
  marginBottom: "3rem",
  color: "#ff477e",
  fontWeight: 700,
};

const featuresGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: "30px",
  marginTop: "20px",
};

const featureCardStyle = {
  backgroundColor: "#ffeff5",
  padding: "30px 20px",
  borderRadius: "20px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease",
  cursor: "pointer",
};

const featureTitleStyle2 = {
  fontSize: "1.8rem",
  marginBottom: "10px",
  color: "#ff477e",
  fontWeight: 600,
};

const featureTextStyle = {
  fontSize: "1.1rem",
  color: "#666",
  lineHeight: 1.6,
};

/* 3) Testimonials */
const testimonialsSectionStyle = {
  padding: "80px 0px",
  backgroundColor: "#ffd6dd",
  textAlign: "center",
  color: "#fff",
};

const testimonialsTitleStyle = {
  fontSize: "2.7rem",
  marginBottom: "3rem",
  fontWeight: 700,
};

const testimonialsContainerStyle = {
  overflow: "hidden",
  minHeight: "280px",
  position: "relative",
};

const testimonialsSliderStyle = {
  display: "inline-flex",
  width: "2800px",
  animation: "scrollTestimonials 40s linear infinite",
};

const testimonialCardStyle = {
  flex: "0 0 350px",
  backgroundColor: "#fff",
  color: "#333",
  padding: "30px 20px",
  margin: "0 15px",
  borderRadius: "20px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const testimonialTextStyle = {
  fontSize: "1.1rem",
  lineHeight: 1.4,
  marginBottom: "10px",
};

const testimonialStarsStyle = {
  fontSize: "1.5rem",
  color: "#ff477e",
  marginBottom: "10px",
};

const testimonialAuthorStyle = {
  fontStyle: "italic",
  fontSize: "1rem",
};

/* 5) Footer */
const footerStyle = {
  padding: "40px 20px",
  textAlign: "center",
  backgroundColor: "#ff477e",
  color: "white",
};

const footerLinkStyle = {
  color: "white",
  textDecoration: "underline",
  fontWeight: 500,
};
